import {
    type ViewStyle,
    StyleSheet,
    Platform
} from "react-native";
import type {
    BadgeCounterDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    counter: {
        flexDirection: "row",
        alignItems: "center",
        ...Platform.select({
            default: {
                direction: "ltr"
            },
            web: {
            }
        })
    },
    previous: {
        position: "absolute",
        start: 0,
        end: 0,
        top: 0
    },
    title: {
        textAlign: "center",
        fontVariant: [
            "tabular-nums"
        ]
    },
    character: {
        overflow: "hidden"
    }
});

export const useStyles = ({
    lineHeight
}: BadgeCounterDynamicStyleType) => {
    const styles = {
        character: {
            height: lineHeight
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
